import { StrictMode } from "react";
import * as ReactDOM from "react-dom/client";

import App from "./app/app";

const id = "mah-find-installer-root";
const rootElement = document.getElementById(id) as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
